import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PedidoCancelamento } from '../pedido-cancelamento';
import { PedidoCancelado } from '../pedido-cancelado';

@Injectable({
    providedIn: 'root'
})
export class PedidoCancelamentoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Envia o cancelamento do pedido */
    cancel(entity: PedidoCancelamento): Observable<PedidoCancelado> {
        return this.customHttp.put<PedidoCancelado>(`${this.pathApi}/${entity.id}/cancel`, entity);
    }
}
